/**
 * @fileOverView
 * @description Authentication Model<br>
 * @copyright 2015-present Flatirontek LLC
 **/

const AmpersandModel = require('ampersand-model');
const app = require("ampersand-app");
const YAML = require('yamljs');

const Auth = AmpersandModel.extend({

    url: function(){
        //return app.config.restApiUrl + "/checkauth";
        if(this.mode =='signout') return app.config.baseApiUrl + "/signout";
        else if(this.mode=='register') return app.config.baseApiUrl + "/register";
        else if(this.mode=='delete') return app.config.baseApiUrl + "/delete";
        //signin. Firebase reports email-link and email+password sign-ins both as "password", so
        //say which one this was; the login page sets signInMethod before a password sign-in
        const signInMethod = window.localStorage.getItem('signInMethod') === 'password' ? 'password' : 'emailLink';
        return app.config.baseApiUrl + "/firebase?sign_in_method=" + signInMethod;
    },

    props: {
        authenticated : 'boolean',
        provider: 'string',
        idToken: 'string',
        deviceID: 'string',
        mode: 'string',
        jwtToken: 'string',       //personal token, ALWAYS the member's own
        orgToken: 'string',       //org-context token while managing an org
        orgContext: 'object'      //{key, name} of the org being managed, or null
    },

    session: {
        deviceToken: ['string',true,null]
    },

    derived: {
        personKey: {
            deps: ['jwtToken'],
            fn: function () {
                if(this.jwtToken) return JSON.parse(atob(this.jwtToken.split('.')[1])).personKey;
                else return null;
            }
        }
    },

    initialize: function(){
        this.set('authenticated',false);
        this.mode = 'signin';
        console.log('authenticated is ' + this.authenticated);
    },

    ajaxConfig: function () {
        if(this.mode=='signout' || this.mode=="register" || this.mode=="delete"){
            return {
                headers: {
                    'Authorization': this.jwtToken
                }
            };

        }else{
            return {
                headers: {
                    'Authorization': 'Bearer ' + this.idToken
                }
            };
        }
    },

    checkAuth: function() {
        if(app.queryParams.client_id) {
            const isLegacyOAuth = app.config.serviceAuth[app.queryParams.client_id] !== undefined;
            
            app.serviceAuth = true;
            //a new request must not inherit the name of an app from an abandoned one
            ['oauth2ServiceName', 'oauth2SelfRegistered'].forEach(key => window.localStorage.removeItem(key));
            window.localStorage.setItem('serviceAuth', app.queryParams.client_id);
            window.localStorage.setItem('serviceAuthType', isLegacyOAuth ? 'legacy' : 'oauth2');
            window.localStorage.setItem('dtSet', Math.floor(Date.now() / 1000));
            
            if(app.queryParams.state) window.localStorage.setItem('state', app.queryParams.state);
            if(app.queryParams.redirect_uri) window.localStorage.setItem('redirect_uri', app.queryParams.redirect_uri);
            if(app.queryParams.response_type) window.localStorage.setItem('response_type', app.queryParams.response_type);
            if(app.queryParams.code_challenge) window.localStorage.setItem('code_challenge', app.queryParams.code_challenge);
            if(app.queryParams.code_challenge_method) window.localStorage.setItem('code_challenge_method', app.queryParams.code_challenge_method);
            //query params arrive raw, so store OpenID Connect values decoded
            ['scope', 'nonce'].forEach(key => {
                if(!app.queryParams[key]) return;
                let value = app.queryParams[key].replace(/\+/g, ' ');
                try { value = decodeURIComponent(value); } catch(e) { /* keep raw */ }
                window.localStorage.setItem(key, value);
            });

        }else if(window.localStorage.getItem('serviceAuth')){
            const dtNow = Math.floor(Date.now() / 1000);

            if(dtNow - window.localStorage.getItem("dtSet") > 120){
                this.clearOAuth2ServiceAuth();
            }else{
                app.serviceAuth = true;
            }
        }

        //subscription cards
        if(app.queryParams.scard!=undefined || window.location.pathname.match('/subscription/')) {
            app.renderPage("SubscriptionCardPage");

        //www
        }else if(window.location.host==app.config.wwwHost) {
            app.renderWwwPage();

        //pay wall page
        }else if(window.location.host==app.config.pwHost){
            app.renderPwPage();

        //authenticated
        }else if(this.authenticated) {
            console.log('authenticated');

            //service authentication
            if(app.serviceAuth) {
                app.loadProfile();
                app.renderServiceAuth();

            //logs
            }else{

                //socket only for browser
                if(app.platform=="browser") app.initSocket();
                else app.loadData();

                app.renderPage();
                app.utils.startSpinner();
            }

        //not authenticated
        }else{

            //service auth
            if(app.serviceAuth) {
                app.renderServiceAuth();

            //demo sound page
            }else if(app.queryParams.p!=undefined && app.queryParams.p=="sounds") {
                var params = {};
                if (app.queryParams.squery != undefined) {
                    params.squery = app.queryParams.squery;
                    delete app.queryParams.squery;
                }
                delete app.queryParams.p;
                app.loadSounds(params);

            //handle subscription requests for iPhone/iPad
            }else if(app.queryParams.sk!=undefined && app.platform=="browser" && !app.queryParams.skclick
                && navigator.userAgent.match(/iPhone|iPad|Android/)
            ){
                app.renderSubscriptionPage();

            //login
            }else {
                app.renderMainLoginPage();
            }
        }

        app.utils.stopSpinner();
    },

    registerDevice: function(data){
        this.set('mode','register');
        var self = this;
        console.log('registering device');
        console.log(data);
        
        this.save({
                deviceID: data.registrationId
            },
            {
            patch:true,
            success: function(model,response){
                console.log('device registered');
                if(response.jwtToken!=undefined) model.set('jwtToken',response.jwtToken);
                if(response.deviceEncoded!=undefined){
                    console.log('deviceEncoded');
                    model.set('deviceToken',response.jwtToken);

                    //manage other device services (geofences now set in loadProfile callback)
                    if(app.platform=="app" && typeof("VybitPlugin")!=undefined){
                        app.utils.manageRating();
                    }

                }
                self.set('mode','signin');
            },
            error: function(){
                self.set('mode','signin');
            }
        });
    },

    signOut: function () {
        var self = this;
        this.set('mode','signout');
        this.set('authenticated', false);
        app.clearUserData();
        app.queryParams = {};

        // Sign out from native Google plugin if available (Android & iOS)
        if((app.platformId === "android" || app.platformId === "ios") &&
           typeof window.cordova !== 'undefined' &&
           typeof window.cordova.plugins !== 'undefined' &&
           typeof window.cordova.plugins.GoogleSignInPlugin !== 'undefined') {
            console.log('Signing out from native Google Sign-In on', app.platformId);
            window.cordova.plugins.GoogleSignInPlugin.signOut(
                function() { console.log('Native Google Sign-In signed out'); },
                function(error) { console.log('Native Google Sign-In signOut error (likely not signed in):', error); }
            );
        }

        // Defer FCM token deletion until AFTER server signout completes, so
        // the server can still query Firebase's IID API with a valid token.
        var deleteFCMTokenIfApp = function() {
            if(app.platform === 'app' && typeof cordova !== 'undefined' &&
               cordova.plugins && cordova.plugins.firebase && cordova.plugins.firebase.messaging) {
                cordova.plugins.firebase.messaging.deleteToken()
                    .then(function() {
                        console.log('FCM token deleted successfully');
                    })
                    .catch(function(error) {
                        console.error('Error deleting FCM token:', error);
                    });
            }
        };

        // Sign out from Firebase FIRST to avoid double onAuthStateChanged triggers
        app.firebase.auth().signOut().then(function(){
            console.log('Firebase signed out');

            // Now clear storage after Firebase signout completes
            window.localStorage.clear();
            window.sessionStorage.clear();

            // Then fetch from server (server unsubscribes device from all FCM topics)
            self.fetch({
                success: function(model,response){
                    //a new sign-in may have superseded this signout while it was in flight
                    if(self.mode !== 'signout') return;
                    model.set('jwtToken',response.jwtToken);
                    self.set('mode','signin');
                    console.log('successfully signed out from server');
                    deleteFCMTokenIfApp();
                    // Navigate to login page
                    self.checkAuth();
                },
                error: function(model,response){
                    if(self.mode !== 'signout') return;
                    self.set('mode', 'signin');
                    console.log('signout error');
                    deleteFCMTokenIfApp();
                    // Navigate to login page even on error
                    self.checkAuth();
                }
            });
        }).catch(function(error){
            console.log('Firebase signout error:', error);
        });

        if(typeof(app.socket)!="undefined") app.socket.close();
    },

    deleteAccount: function(){
        var self = this;
        this.set('mode','delete');
        this.set('authenticated', false);
        var self = this;
        app.queryParams = {};
        window.localStorage.clear();
        app.clearUserData();
        this.fetch({
            success: function(model,response){
                model.set('jwtToken',response.jwtToken);
                self.set('mode','signin');
                window.localStorage.setItem('loginMessage','Your account has been successfully deleted.');
                app.firebase.auth().signOut().then(
                    function(result){
                        console.log('successfully signed out and deleted account');
                    }
                ).catch(function(error){
                    console.log(error);
                });
            },
            error: function(model,response){
                self.set('mode', 'signin');
                console.log('delete account error');
            }
        });

        if(typeof(app.socket)!="undefined") app.socket.close();
    },

    clearOAuth2ServiceAuth: function() {
        require('../lib/utilities').serviceAuthKeys.forEach(key => window.localStorage.removeItem(key));
        
        app.serviceAuth = false;
        app.queryParams = {};
        
        window.location.href = '/';
    }
});

module.exports = Auth;
